<div class="col-md-6 ms-3 me-3" style="margin-top:10px;">
  <div class="col-md-12 border" style="border-radius:10px;">
    <img src='../../../../assets/oddfellow_logga.PNG' style="margin-top:25px;" title="Odd Fellow medlemsregister" (click)="home()" />
    <br><br>
    <div class="col-md-12" style="border-top: 1px solid #F0F0F0;border-bottom:1px solid #F0F0F0;padding-top:10px;padding-bottom:10px;"><div class="p-2">Fyll i ditt användarnamn (medlemsnummer). Om du har en epostadress registrerad i medlemsregistret kommer du därefter få ett mail med instruktioner om hur du gör för
      att skapa ett nytt lösenord. Om du saknar epost-adress i medlemsregistret måste protokollsekreteraren i din loge kontaktas.</div></div>
    <br>
    <form [formGroup]="memberform">
      <div class="form-group col-md-11 p-2" style="min-width:100px;max-width: 150px;">
        <label for="memberid">
          Medlemsnummer
        </label>
        <input type="text" class="form-control form-control-sm" id="memberid" formControlName="memberid" required>
        <button class="btn border" (click)="send()" style="margin-top:5px;" [disabled]="!memberform.valid">Skicka</button>
      </div>
    </form>
    <br>
    <div *ngIf="responsemessage" style="margin:3px;padding: 3px;background-color: #F0F0F0;margin-bottom:10px;">{{responsemessage}}</div>
  </div>
</div>